import { withStyles } from "@material-ui/core/styles";
import { Typography, Link } from "@material-ui/core";

const styles = (theme) => ({
  header: {
    margin: theme.spacing(2),
    //fontWeight: "bolder",
  },
  listItem: {
    margin: theme.spacing(1),
  },
  paragraph: {
    padding: theme.spacing(2),
  },
  link: {
    textDecoration: "underline",
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
});

const MarkdownHeading = withStyles(styles)(({ classes, ...props }) => {
  let variant;
  switch (props.level) {
    case 1:
      variant = "h1";
      break;
    case 2:
      variant = "h2";
      break;
    case 3:
      variant = "h3";
      break;
    case 4:
      variant = "h4";
      break;
    case 5:
      variant = "h5";
      break;
    default:
      variant = "h6";
      break;
  }
  return (
    <Typography className={classes.header} variant={variant}>
      {props.children}
    </Typography>
  );
});

const MarkdownText = withStyles(styles)(({ classes, ...props }) => {
  return (
    <Typography className={classes.paragraph} variant="body1">
      {props.children}
    </Typography>
  );
});

const MarkdownLink = withStyles(styles)(({ classes, ...props }) => {
  return (
    <Link className={classes.link} target="_blank" href={props.href}>
      {props.children}
    </Link>
  );
});

const MarkdownListItem = withStyles(styles)(({ classes, ...props }) => {
  return (
    <li className={classes.listItem}>
      <Typography component="span">{props.children}</Typography>
    </li>
  );
});
export const renderers = {
  heading: MarkdownHeading,
  paragraph: MarkdownText,
  link: MarkdownLink,
  listItem: MarkdownListItem,
};
